if (!customElements.get('quick-comparison-table')) {
  customElements.define(
    'quick-comparison-table',
    class QuickComparisonTable extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.skipLoad === 'true' || this.dataset.skipLoad === '1') {
          return;
        }

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        const globalConfig = window.quickComparisonTable || {};
        window.quickComparisonTable = globalConfig;

        if (!globalConfig.defaultUrl) {
          const configScript = document.querySelector('script[data-quick-comparison-config]');

          if (configScript) {
            try {
              const parsedConfig = JSON.parse(configScript.textContent || '{}');
              Object.assign(globalConfig, parsedConfig);
            } catch (error) {
              console.error('quick-comparison-table: failed to parse configuration JSON.', error);
            }
          }
        }

        const dataUrl = this.dataset.url || globalConfig.defaultUrl;

        if (!dataUrl) {
          console.warn('quick-comparison-table: data-url attribute is missing. Provide data-url or ensure the default configuration is available.');
          return;
        }

        fetch(dataUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('quick-comparison-table');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations && recommendations.querySelector('.quick-comparison-table-container')) {
              this.dispatchEvent(new CustomEvent('quick-comparison-table:loaded'));
            } else {
              const _section = this.closest('.shopify-section');
              if (!_section.id.includes('product_description')) {
                _section.remove();
              }
              this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
